import { colors } from 'theme/color-palette';
import { makeStyles } from '@material-ui/core/styles';
import { Bogle_Regular } from 'constants/constant';
const { WARNING_COLOR, WARNING_TEXT_COLOR, BG_SUCCESS, TXT_SUCCESS } = colors;

const bgColorList = {
	dark: colors.LIGHTER_BLACK,
	warning: WARNING_COLOR,
	success: BG_SUCCESS
};

const textColorList = {
	dark: colors.WHITE,
	success: TXT_SUCCESS,
	warning: WARNING_TEXT_COLOR
};

const RBButtonStyle = makeStyles({
	root: {
		'& .MuiSnackbarContent-root': {
			backgroundColor: (props) => bgColorList[props.type],
			boxShadow: '0px 5px 10px 3px #00000026'
		},
		'& .MuiSnackbarContent-message': {
			color: (props) => textColorList[props.type],
			fontFamily: Bogle_Regular,
			fontSize: 16,
			fontWeight: 500
		}
	},
	snackbarHidden: {
		display: 'none'
	},
	actionBtn: {
		color: (props) => textColorList[props.type],
		fontSize: 14,
		fontFamily: Bogle_Regular,
		textDecorationLine: 'underline'
	}
});

export default RBButtonStyle;
